/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import * as storageUtils from '../../utils/storageUtils';
import { actions } from '../../store/Products';

interface SelectedState {
    buyerAccountSBN: {
        id: string;
        businessTypeId: string;
    };
    s4HanaPC: {
        id: string;
        businessTypeId: string;
    };
}

const dev = ['ZH527', 'ZH537', 'ZH023', 'ZH021', 'ZH041', 'ZH016', 'ZH036', 'ZH037'];
const test = ['ZH526', 'ZH019', 'ZH020', 'ZH029', 'ZH040'];
const prod = ['ZH001', 'ZH006', 'ZH026', 'ZH421'];

const getBusinessType = (code: string) => {
    if (typeof code !== 'string') {
        return '';
    }
    if (dev.includes(code)) return '(Dev - ' + code + ')';
    if (test.includes(code)) return '(Test - ' + code + ')';
    if (prod.includes(code)) return '(Prod - ' + code + ')';
    return '';
};

const extractIdAndBusinessType = (selectedOptionValue: string) => {
    const firstSpaceIndex = selectedOptionValue.indexOf(' ');
    const id = selectedOptionValue.substring(0, firstSpaceIndex).trim();
    let businessTypeId = '';
    const businessTypeIdMatch = selectedOptionValue.match(/\(([^)]+)\s-\s([^)]+)\)/);
    if (businessTypeIdMatch) {
        businessTypeId = businessTypeIdMatch[2];
    } else {
        const systemCode = selectedOptionValue.substring(firstSpaceIndex + 1).trim();
        businessTypeId = getBusinessType(systemCode);
    }
    return {
        id,
        businessTypeId,
    };
};

export { SelectedState, getBusinessType, storageUtils, actions, extractIdAndBusinessType };
